var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import CreatePlanTemplateDialog from './CreatePlanTemplateDialog/CreatePlanTemplateDialog';
import { StudentDocumentTemplate } from '@/models/StudentDocumentTemplate';
let PlanTemplates = class PlanTemplates extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.$pageTitle = 'Plan Templates';
        this.isCreatingPlanTemplate = false;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    dialogOptions(planTemplate) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.plan') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        planTemplate
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get tableOptions() {
        return {
            model: new StudentDocumentTemplate(),
            name: {
                singular: this.$tc('student_plan.template.title', 1),
                plural: this.$tc('student_plan.template.title', 2),
            },
            headers: [
                {
                    text: `${this.$t('student_plan.template.title_label')}`,
                    value: 'name',
                    action: '/plan-templates/{id}',
                },
                {
                    text: `Categorie`,
                    value: 'documentable_type',
                    transform: (value) => {
                        return value === 'user' ? this.$tc('student_text') : this.$tc('group_text');
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/plan-templates/{id}',
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, planTemplate) => {
                        this.$store.dispatch('openDialog', this.dialogOptions(planTemplate));
                    },
                },
            ],
            filters: [],
        };
    }
};
PlanTemplates = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CreatePlanTemplateDialog,
        },
    })
], PlanTemplates);
export default PlanTemplates;
